import { useMemo } from 'react';

const baseRetainerFormOption = {
    archAndQuantity: '',
    fixedWire: '',
    clearRetainerDesignUpperOption: '',
    clearRetainerDesignLowerOption: '',
};

const useRetainerCommon = ({
    selectedRetainer,
    impressionType,
    subType,
    getDiffRetainerLang = () => '',
    option = { ...baseRetainerFormOption },
}) => {
    const retainerDesignQuestion = useMemo(() => {
        return getDiffRetainerLang(`formQuestionLabel.retainerDesignQuestion`);
    }, [getDiffRetainerLang]);

    return {
        retainerDesignQuestion,
    };
};

export default useRetainerCommon;
